<template>
  <div id='prog-bar'>
    <div class="prog-bar-wrap">
      <div class="status">
        <div class="percetange" v-html="fetchStep + '/10'"></div>
      </div>
      <div class="bar">
        <div class="progression" :style="`width: ${fetchStep * 10}%`"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProgressBar',
  computed: {
    ...mapGetters(['contentGeneral', 'fetchStep'])
  }
}
</script>

<style lang='scss'>
@import '@/assets/_variables';

#prog-bar {
  width: 100%; height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: $pad*1.5;
  .prog-bar-wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .bar {
      width: 100%;
      background: $grey;
      border-radius: 10px;
      height: 8px;
      .progression {
        background: $green;
        height: 100%;
        border-radius: 10px;
        transition: width .5s linear;
        min-width: 10px;
      }
    }
    .status {
      margin-bottom: $pad*.5;
    .percetange {
      color: $green;
      width: 30px;
      text-align: right;
      padding-right: $font_sz*0.5;
      font: {
        size: $font_sz;
        weight: $font_b;
      }
    }
    }
}
}
</style>
